<ng-container *ngIf="!field.multiple">
    <div [formGroup]="group">
        <fui-checkbox
            [fieldGroup]="group"
            [fieldName]="field.name"
            [label]="field.label + (field.required ? ' *' : '')"
            [class]="field.class"
        ></fui-checkbox>
    </div>
</ng-container>
<ng-container *ngIf="field.multiple">
    <mat-form-field class="!hidden" appearance="outline" [formGroup]="group">
        <input matInput [formControlName]="field.name" readonly />
    </mat-form-field>
    <div class="checkbox-label-text" *ngIf="field.label">
        <label>{{ field.label }}</label>
    </div>
    <div *ngFor="let item of field.options; let index = index">
        <fui-checkbox
            [label]="item.name"
            [checked]="selection.isSelected(field.optionsName ? item[field.optionsName] : item.value)"
            [forceDisabled]="field.disabled"
            (changed)="changeCheckbox($event, field.optionsName ? item[field.optionsName] : item.value)"
        ></fui-checkbox>
    </div>
</ng-container>
